export const WEEKDAYS = 'WEEKDAYS'
export const WEEKEND = 'WEEKEND'
export const ALL = 'ALL'

export const DAYS_LIST = {
  [WEEKDAYS]: [1, 2, 3, 4, 5],
  [WEEKEND]: [6, 7],
  [ALL]: [1, 2, 3, 4, 5, 6, 7],
}
